import React from "react";
import { motion, AnimatePresence } from "framer-motion";

import i18n from "../../../i18n";

import { FlatList, Image, TextInput, View, Text, ActivityIndicator} from "react-native-web";


const viewportWidth = window.innerWidth;
const viewportHeight = window.innerHeight;



let titleFontSize30, titleFontSize25, titleFontSize22, titleFontSize20, titleFontSize19, titleFontSize18, titleFontSize17, titleFontSize16, titleFontSize15, titleFontSize13, titleFontSize12, titleFontSize;

if (viewportWidth > 1400)
{
   titleFontSize = 40;
   titleFontSize30 = 30;
   titleFontSize25 = 25;
   titleFontSize22 = 22;
   titleFontSize20 = 20;
   titleFontSize19 = 19;
   titleFontSize18 = 18;
   titleFontSize17 = 17;
   titleFontSize16 = 16;
   titleFontSize15 = 15;
   titleFontSize13 = 13;
   titleFontSize12 = 12;
}
else if (viewportWidth > 1200)
{
   titleFontSize = 35;
   titleFontSize30 = 26;
   titleFontSize25 = 22;
   titleFontSize22 = 20;
   titleFontSize20 = 19;
   titleFontSize19 = 18;
   titleFontSize18 = 17;
   titleFontSize17 = 16;
   titleFontSize16 = 15;
   titleFontSize15 = 14;
   titleFontSize13 = 12;
   titleFontSize12 = 11;
}
else
{
   titleFontSize = 30;
   titleFontSize30 = 24;
   titleFontSize25 = 19;
   titleFontSize22 = 17;
   titleFontSize20 = 18;
   titleFontSize19 = 17;
   titleFontSize18 = 16;
   titleFontSize17 = 15;
   titleFontSize16 = 14;
   titleFontSize15 = 13;
   titleFontSize13 = 11;
   titleFontSize12 = 10;
}

export default class ZoomPreview extends React.Component {

  accessStorryPage = () => {
     const { item } = this.props;

     window.location = `/p/${item.public_id}`;
     //window.location = `/p/${item.public_id}?a=in&source=home`;
  }

  previewMoments = () => {
     const { item } = this.props;
     this.props.previewMoments(item);

     if (this.props.onClose) {
       this.props.onClose();
     }
  }

  previeCredits = () => {
    const { item } = this.props;
    this.props.previewCredits(item);

    if (this.props.onClose) {
      this.props.onClose();
    }
  }

  render() {
    const { item, position, onZoomEnter, onZoomLeave } = this.props;

    return (
      <AnimatePresence onExitComplete={this.props.onExitComplete}>
        <motion.div key={item.objectID}
          className="zoom-preview"
          onMouseEnter={onZoomEnter}
          onMouseLeave={onZoomLeave}
          initial={{ opacity: 0, scale: 0.95, y: 0 }}
          animate={{ opacity: 1, scale: 1.2, y: -20 }}
          exit={{ opacity: 0, scale: 0.95, y: 0, transition: { duration: 0.15 } }}
          transition={{ type: 'spring', stiffness: 120, duration: 0.25, ease: "easeInOut" }}
          style={{
            position: "absolute",
            top: position.y,
            left: position.x,
            width: position.width,
            zIndex: 999,
            pointerEvents: "auto",
            transformOrigin: 'center',
            background: "#fff",
            borderRadius: "10px",
            overflow: 'hidden'
          }}
        >

          <div style={{position: 'relative',width: `100%`,}}>

             <div
               style={{
                 position: 'relative',
                 width: `100%`,
                 height: `${position.width*0.5}px`,
                 overflow: 'hidden'
               }}
             >




                  <picture>
                      <source srcSet={item.medias.thumbnail.replace(/\.(jpg|jpeg|png)$/i, '.webp')} type="image/webp" />
                      <img src={item.medias.thumbnail} alt="thumbnail" className="card-image" />
                  </picture>


                 <div className="text-overlay" onClick={this.accessStorryPage} style={{pointerEvents: 'auto', cursor: 'pointer',}}>
                   <div className="text-gradient" />

                   <p className="overlay-text" style={{fontSize: titleFontSize22+'px', fontWeight: 'bold'}}>

                       <div
                         style={{display: 'flex', flexDirection: 'row', fontFamily: '"Lato", sans-serif'}}
                         >
                             <div style={{}}>
                               <View style={{height: '20px', justifyContent: 'center'}}>
                                 <Image source={{uri: '/img/storrypage_thumb.png'}} style={{width: '20px', height: '20px'}}/>
                               </View>
                             </div>
                             <div className="sp-lp-h3-pc" style={{marginLeft: '5px'}}>
                               <View style={{height: '20px', justifyContent: 'center'}}>
                                 <Text style={{color: '#fff', textAlign: 'center', fontSize: titleFontSize15+'px'}}>{i18n.t(this.props.item.type_of_story)}</Text>
                               </View>
                             </div>
                        </div>

                        <div style={{marginTop: '10px', fontSize: titleFontSize22+'px'}}>{this.props.item.title}</div>
                   </p>
                 </div>

             </div>

             <div style={{
                 width: `100%`,
                 height: `${position.width*0.35}px`,
                 overflow: 'hidden'
               }}>

               <div style={{position: 'relative', width: `94%`, margin: 'auto', height: '40px', marginTop: '2px'}}>
                   <View style={{width: '100%', height: '40px', flexDirection: 'row'}}>

                          <View style={{width: 32, height: 40, justifyContent: 'center'}}>
                             <View style={{width: 30, height: 30, borderRadius: 15, backgroundColor: '#28434d'}}><Image source={{uri: this.props.item.crew.publisher[0].picture}} style={{width: 30, height: 30, borderRadius: 15, borderWidth: 0.5, borderColor: '#ccc'}}/></View>
                          </View>
                          <View style={{marginLeft: 5, width: (position.width*0.94-50)+'px', height: 40, justifyContent: 'center'}}>
                              {this.props.item.crew.publisher[0].sigle !== "" && <Text numberOfLines={2} style={{fontSize: titleFontSize13+'px', color: '#333'}}>{this.props.item.crew.publisher[0].sigle}</Text>}
                              {this.props.item.crew.publisher[0].sigle === "" && <Text numberOfLines={2} style={{fontSize: titleFontSize13+'px', color: '#333'}}>{this.props.item.crew.publisher[0].name}</Text>}
                          </View>

                   </View>
               </div>

               <div style={{width: `94%`, margin: 'auto', display: 'flex', flexDirection: 'row', fontFamily: '"Lato", sans-serif', marginTop: '10px'}}>


                       <div onClick={this.accessStorryPage} className="sp-lp-button-text-white-inner-pc" style={{pointerEvents: 'auto', cursor: 'pointer', background: 'linear-gradient(to right, #448209, #5f9e34)', height: '40px', borderRadius: '6px', borderTopRightRadius: 0, borderBottomRightRadius: 0, border: '0.5px solid #448209', paddingLeft: '10px', paddingRight: '10px'}}>
                         <View style={{height: '40px', justifyContent: 'center'}}>
                           <Text style={{textAlign: 'center', color: '#fff', fontSize: titleFontSize12+'px'}}>{i18n.t('free')}</Text>
                         </View>
                       </div>
                       <div onClick={this.accessStorryPage} className="blurred-transp-bg" style={{cursor: 'pointer', background: 'rgba(255,255,255,0.8)', height: '40px', borderRadius: '6px', borderTopLeftRadius: 0, borderBottomLeftRadius: 0, border: '0.5px solid #448209', borderLeft:  'none', paddingLeft: '10px', paddingRight: '10px'}}>
                         <View style={{height: '40px', justifyContent: 'center'}}>
                           <Text style={{color: '#448209', fontSize: titleFontSize12+'px'}}>{i18n.t('Go_to_the_storrypage')}</Text>
                         </View>
                       </div>


                       <div onClick={this.previewMoments} className="sp-lp-button-text-white-inner-pc" style={{marginLeft: '10px', cursor: 'pointer',  background: 'rgba(255,255,255,1)', borderRadius: '6px', border: '0.5px solid #5616ee', paddingLeft: '10px', paddingRight: '10px'}}>
                         <View style={{height: '40px', justifyContent: 'center'}}>
                           <Image source={{uri: '/img/storrypage_thumb.png'}} style={{width: '30px', height: '30px'}}/>
                         </View>
                       </div>


                       <div onClick={this.previeCredits} className="sp-lp-button-text-white-inner-pc" style={{marginLeft: '10px', cursor: 'pointer', background: 'rgba(255,255,255,1)', borderRadius: '6px', border: '0.5px solid #1e8e75', paddingLeft: '10px', paddingRight: '10px'}}>
                         <View style={{height: '40px', justifyContent: 'center'}}>
                           <Image source={{uri: '/img/handmade_icon_green_darker.png'}} style={{width: '28px', height: '28px'}}/>
                         </View>
                       </div>


                </div>


             </div>

           </div>

        </motion.div>
      </AnimatePresence>
    );
  }


}
